import(/* webpackMode: "eager" */ "/opt/fa-build/src/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/fa-build/node_modules/antd/dist/reset.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fa-build/src/components/common/layouts/MainLayout.js");
